<template>
  <form v-if="value">
    <div class="row">
      <string-form-field
        class="col-md-6"
        label="Nome"
        :value="value.firstName"
        :disabled="disabled"
        :error="findError('firstName')"
        @input="propertyChanged('firstName', $event)"
      />

      <string-form-field
        class="col-md-6"
        label="Cognome"
        :value="value.lastName"
        :disabled="disabled"
        :error="findError('lastName')"
        @input="propertyChanged('lastName', $event)"
      />
    </div>

    <div class="row">
      <string-form-field
        class="col-md-6"
        label="Username"
        :value="value.username"
        :disabled="disabled"
        :error="findError('username')"
        @input="propertyChanged('username', $event)"
      />

      <string-form-field
        class="col-md-6"
        label="E-mail"
        :value="value.email"
        :disabled="disabled"
        :error="findError('email')"
        @input="propertyChanged('email', $event)"
      />
    </div>
  </form>
</template>
<script>
import EntityEditorMixin from 'vue-core/mixins/EntityEditorMixin';

export default {
  mixins: [ EntityEditorMixin ],
}
</script>
